import React from "react";

// External Package
import { useSelector } from "react-redux";

// State
import { RootState } from "../../store/authStore";

// Components
import FormContactComponents from "../../components/contact/formContactComponents";
export default function Index() {
  const isMobile = useSelector((state: RootState) => state.auth.isMobile);

  return (
    <div className="contact">
      {isMobile ? (
        // Mobile View
        <div className="row mb-4">
          <div className="col-12">
            <div className="title text-capitalize font-size-18 font-vietnam-400-italic">
              get in touch
            </div>
            <h1 className="text-capitalize font-size-36 font-vietnam-600 lh-1">
              let's chat, reach out to Us
            </h1>
            <p className="font-vietnam-400-italic font-size-18">
              have questions or feedback ? We're here to help. Send us a
              message, and we'll respond within 24 hours.
            </p>

            <FormContactComponents />
          </div>
        </div>
      ) : (
        // Desktop View
        <div className="row">
          <div className="col-6">
            <div className="title text-capitalize font-size-18 font-vietnam-400-italic">
              get in touch
            </div>
            <h1 className="text-capitalize font-size-50 font-vietnam-600">
              let's chat, reach out <br /> to Us
            </h1>
            <p className="font-vietnam-400-italic font-size-18">
              have questions or feedback ? We're here to help. Send us a
              message, and we'll respond within 24 hours.
            </p>

            <FormContactComponents />
          </div>
          <div className="col-6">
            <div className="row">
              <div className="col-12">
                <div className="images w-100">
                  <img
                    src={require("../../assets/images/contact/contact_1.jpg")}
                    alt="services"
                    width={"100%"}
                    loading="lazy"
                    className="rounded-3 images-gray"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
